function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Text } from "../text/Text";
import { Flex } from "../flex/Flex";
import { Icon } from "../icon/Icon";
import { Loader } from "../loader";
import BaseButton, { buttonDefaultProps } from "./BaseButton";
var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(BaseButton, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(ButtonInner, props));
});

var ButtonInner = function ButtonInner(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.isLoading ? /*#__PURE__*/React.createElement(Loader, {
    "data-test-id": "loader",
    position: "absolute"
  }) : null, /*#__PURE__*/React.createElement(Flex, {
    sx: props.isLoading ? {
      visibility: 'hidden'
    } : null,
    alignItems: "center",
    paddingY: "2px"
  }, /*#__PURE__*/React.createElement(Button.Icon, _extends({}, props, {
    noMargin: !props.children
  })), props.children ? /*#__PURE__*/React.createElement(Text, null, props.children) : null, /*#__PURE__*/React.createElement(Button.RightIcon, _extends({}, props, {
    noMargin: !props.children
  }))));
};

ButtonInner.defaultProps = buttonDefaultProps;
var sizeToIconMargin = {
  left: {
    small: {
      marginRight: '4px',
      marginLeft: '-2px'
    },
    medium: {
      marginRight: '4px',
      marginLeft: '-4px'
    },
    large: {
      marginRight: '4px',
      marginLeft: '-4px'
    }
  },
  right: {
    small: {
      marginRight: '-2px',
      marginLeft: '4px'
    },
    medium: {
      marginRight: '-4px',
      marginLeft: '4px'
    },
    large: {
      marginRight: '-4px',
      marginLeft: '6px'
    }
  }
};
var sizeToIconSize = {
  tiny: 'xSmall',
  small: 'small',
  medium: 'medium',
  large: 'large'
};

var ButtonIcon = function ButtonIcon(props) {
  var appearance = props.appearance,
      noMargin = props.noMargin;
  var styles;

  if (appearance !== 'icon' && !noMargin) {
    styles = sizeToIconMargin[props.location][props.size];
  }

  return /*#__PURE__*/React.createElement(Icon, {
    sx: styles,
    size: sizeToIconSize[props.size],
    icon: props.icon
  });
};

Button.Icon = function (props) {
  var icon = props.icon,
      size = props.size;

  if (!icon) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ButtonIcon, _extends({}, props, {
    icon: icon,
    size: size,
    location: "left"
  }));
};

Button.RightIcon = function (props) {
  var rightIcon = props.rightIcon,
      size = props.size;

  if (!rightIcon) {
    return null;
  }

  return /*#__PURE__*/React.createElement(ButtonIcon, _extends({}, props, {
    icon: rightIcon,
    size: size,
    location: "right"
  }));
};

export { Button };
export default Button;